import { useAuthStore } from '@/stores/auth.store';

export function DashboardPage() {
  const { role } = useAuthStore();

  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-slate-200 bg-white px-6 py-4 dark:border-slate-700 dark:bg-slate-800">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-lg font-bold tracking-tight text-bridge-700 dark:text-bridge-400">
            BRIDGE AI
          </h1>
          <span className="rounded-full bg-bridge-100 px-3 py-1 text-xs font-medium text-bridge-700 dark:bg-bridge-900/30 dark:text-bridge-300">
            {role ?? 'senco'}
          </span>
        </div>
      </header>
      <main className="flex-1 p-6">
        <div className="card">
          <h2 className="font-display text-lg font-semibold text-slate-900 dark:text-white">
            Today View
          </h2>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Dashboard content — Phase B
          </p>
        </div>
      </main>
    </div>
  );
}
